import { CanActivateFn } from '@angular/router'
import { inject } from '@angular/core'
import { MaintenanceGuardService } from '../services/maintenance-guard.service'

export const maintenanceGuard: CanActivateFn = () => {
  return inject(MaintenanceGuardService).canActivate()
}
